// extracted by mini-css-extract-plugin
module.exports = {"next":"Next-module--next--3U44h"};